const hangTagPrinters = [{
    name: "QuickLabel QL-30M",
    warehouse: "pennsylvania"
}, {
    name: "CAB XD4T/300",
    warehouse: "texas"
}, {
    name: "QuickLabel QL-30M",
    warehouse: "texas"
}];


const asinLabelPrinters = [{
    name: "ZDesigner ZT230-200dpi ZPL",
    warehouse: "pennsylvania"
}];


export const getHangTagPrintersByWarehouse = warehouse => {
    return hangTagPrinters.filter(printer => printer.warehouse === warehouse).map(printer => printer.name);
};

export const getAsinLabelPrintersByWarehouse = warehouse => {
    return asinLabelPrinters.filter(printer => printer.warehouse === warehouse).map(printer => printer.name);
};